//messages.js
export default {
  general: 'General',
  overview: 'Overview',
  customizer: 'Customizer',
  applications: 'Applications',
  features: 'Features',
  components: 'Components',
  salesAndVisitStats: 'Sales & Visits Stats',
  orderAndProjectStats: 'Order & Projects Stats',
  fitnessStats: 'Fitness Stats',
  supportAndUsefulWidgets: 'Support & Useful Widgets',
  dashboard: 'Dashboard',
  dashboardOverview: 'Dashboard Overview',
  dashboardv1: 'Dashboard V1',
  dashboardv2: 'Dashboard V2',
  widgets: 'Widgets',
  horizontalMenu: 'Horizontal Menu',
  pages: 'Pages',
  gallery: 'Gallery',
  pricing: 'Pricing',
  pricing1: 'Pricing 1',
  pricing2: 'Pricing 2',
  blank: 'Blank',
  session: 'Session',
  signUp1: 'Sign Up 1',
  signUp2: 'Sign Up 2',
  login1: 'Login 1',
  login2: 'Login 2',
  lockScreen: 'Lock Screen',
  uiElements: 'UI Elements',
  buttons: 'Buttons',
  cards: 'Cards',
  checkbox: 'Checkbox',
  carousel: 'Carousel',
  chips: 'Chips',
  datepicker: 'Datepicker',
  dialog: 'Dialog',
  grid: 'Grid',
  input: 'Input',
  list: 'List',
  menu: 'Menu',
  progress: 'Progress',
  radio: 'Radio',
  select: 'Select',
  slider: 'Slider',
  snackbar: 'Snackbar',
  tabs: 'Tabs',
  toolbar: 'Toolbar',
  tooltip: 'Tooltip',
  timepicker: 'Timepicker',
  forms: 'Forms',
  formValidation: 'Form Validation',
  stepper: 'Stepper',
  charts: 'Charts',
  vueChartjs: 'Vue Chartjs',
  vueEcharts: 'Vue Echarts',
  icons: 'Icons',
  themify: 'Themify',
  material: 'Material',
  tables: 'Tables',
  standard: 'Standard',
  slots: 'Slots',
  selectable: 'Selectable',
  searchRow: 'Search Row',
  maps: 'Maps',
  googleMaps: 'Google Maps',
  leafletMaps: 'Leaflet Maps',
  jvectorMap: 'Jvector Map',
  inbox: 'Inbox',
  users: 'Users',
  userProfile: 'User Profile',
  usersList: 'Users List',
  calendar: 'Calendar',
  editor: 'Editor',
  quillEditor: 'Quill Editor',
  wYSIWYG: 'WYSIWYG',
  vue2Dragula: 'Vue2 Dragula',
  dragAndDrop: 'Drag And Drop',
  vueDraggable: 'Vue Draggable',
  draggableResizeable: 'Draggable Resizeable',
  chat: 'Chat',
  todo: 'Todo',
  modules: 'Modules',
  user: 'User',
  miscellaneous: 'Miscellaneous',
  promo: 'Promo',
  connections: 'Connections',
  follow: 'Follow',
  unfollow: 'Unfollow',
  basicValidation: 'Basic Validation',
  validationWithSubmitAndclear: 'Validation with submit & clear',
  submit: 'Submit',
  clear: 'Clear',
  step1: 'Step 1',
  step2: 'Step 2',
  step3: 'Step 3',
  continue: 'Continue',
  cancel: 'Cancel',
  totalEarnings: 'Total Earnings',
  onlineRevenue: 'Online Revenue',
  offlineRevenue: 'Offline Revenue',
  marketingExpenses: 'Marketing Expenses',
  markAsPaid: 'Mark as paid',
  markAsNotPaid: 'Mark as not paid',
  markAsShipped: 'Mark as shipped',
  newCustomers: 'Money Spent',
  visitAndSalesStatistics: 'Visit & Sales Statistics',
  salesStatistics: 'Sales Statistics',
  collapse: 'Collapse',
  reload: 'Reload',
  close: 'Close',
  bandwidthUsage: 'Bandwidth Usage',
  shoppingCart: 'Shopping Cart',
  totalDownloads: 'Total Downloads',
  productSales: 'Product Sales',
  projectStatus: 'Project Status',
  averageSteps: 'Average Steps',
  todaysDistance: "Today's Distance",
  todaysStep: "Today's Step",
  todaysGoal: "Today's Goal",
  calories: 'Calories',
  weeklySummary: 'Weekly Summary',
  supportTickets: 'Support Tickets',
  todoList: 'To Do List',
  newsletterCampaign: 'Newsletter Campaign',
  currentVisitors: 'Current Visitors',
  newMembers: 'New Members',
  addNewBlog: 'Add New Blog',
  add: 'Add',
  logOut: 'Log Out',
  totalAppMemory: 'Total App Memory',
  totalMemoryUsed: 'Total Memory Used',
  unreadMail: '12 Unread Mail',
  feedback: 'Feedback',
  flatButton: 'Flat Button',
  raisedButton: 'Raised Button',
  gradientButton: 'Gradient Button',
  buttonDropdownVariants: 'Button Dropdown Variants',
  buttonToggle: 'Button Toggle',
  icon: 'Icon',
  normal: 'Normal',
  enabled: 'Enabled',
  disabled: 'Disabled',
  floating: 'Floating',
  loaders: 'Loaders',
  sizing: 'Sizing',
  outline: 'Outline',
  round: 'Round',
  block: 'Block',
  search: 'Search',
  checkboxesBoolean: 'Checkboxes Boolean',
  checkboxesArray: 'Checkboxes Array',
  checkboxesStates: 'Checkboxes - States',
  checkboxesColors: 'Checkboxes - Colors',
  switches: 'Switches',
  default: 'Default',
  customTransition: 'Custom Transition',
  customDelimiter: 'Custom Delimiter',
  hideControls: 'Hide Controls',
  hideDelimiters: 'Hide Delimiters',
  colored: 'Colored',
  label: 'Label',
  closeable: 'Closeable',
  datePickerHorizontal: 'Date Picker Horizontal',
  datePickerVertical: 'Date Picker Vertical',
  datePickersInDialogAndMenu: 'Date Pickers- In Dialog And Menu',
  datePickersWithModal: 'Date Pickers With Modal',
  datePickersFormattingDate: 'Date Pickers - Formatting Date',
  simpleDialogs: 'Simple Dialogs',
  withoutActivator: 'Without Activator',
  scrollable: 'Scrollable',
  listOfAllMaterialIcons: 'List Of All Material Icons',
  arrowsAndDirectionsIcons: 'ARROWS & DIRECTION ICONS',
  webAppIcons: 'WEB APP ICONS',
  CONTROLICONS: 'CONTROL ICONS',
  TEXTEDITOR: 'TEXT EDITOR',
  LAYOUTICONS: 'LAYOUT ICONS',
  BRANDICONS: 'BRAND ICONS',
  newClients: 'New Clients',
  recurringClients: 'Recurring Clients',
  bounceRate: 'Bounce Rate',
  pageViews: 'Page Views',
  usefulWidgets: 'Useful Widgets',
  sale: 'Sale',
  sales: 'Sales',
  saleDetails: 'Sales Details',
  invoices: 'Invoices',
  referrals: 'Referrals',
  serverLoad: 'Server Load',
  recentSale: 'Recent Sale',
  supportRequest: 'Support Request',
  productSale: 'Product Sale',
  viewAll: 'VIEW ALL',
  barChart: 'Bar Chart',
  polarAreaChart: 'Polar Area Chart',
  lineChart: 'Line Chart',
  radarChart: 'Radar Chart',
  doughnutChart: 'Doughnut Chart',
  bubbleChart: 'Bubble Chart',
  gradientLineChart: 'Gradient Line Chart',
  pieChart: 'Pie Chart',
  funnelChart: 'Funnel Chart',
  loginNow: 'Login Now',
  createAccount: 'Create Account',
  termsOfService: 'Terms of Service',
  bySigningUpYouAgreeTo: 'By signing up you agree to',
  loginToAdmin: 'Login To Admin',
  loginToStore: 'Login To Your Store',
  enterUsernameAndPasswordToAccessControlPanelOf: 'Enter username and password to access control panel of',
  havingAnAccount: 'Having an account?',
  quickLinks: 'Quick Links',
  plans: 'Plans',
  chooseThePlanThatWorksForYou: 'Choose the plan that works for you.',
  monthly: 'Monthly',
  yearlyGet2MonthExtra: 'Yearly ( get 2 month extra)',
  extras: 'Extras',
  addExtra: 'Add Extra',
  editExtra: 'Edit Extra',
  basic: 'Basic',
  pro: 'Pro',
  advanced: 'Advanced',
  basicFree: 'Basic (Free)',
  startToBasic: 'Start To Basic',
  upgradeToPro: 'Upgrade To Pro.',
  upgradeToAdvance: 'Upgrade To Advance',
  comparePlans: 'Compare Plans',
  frequentlyAskedQuestions: 'Frequently Asked Questions',
  defaultInput: 'Default Input',
  activator: 'Activator',
  hover: 'Hover',
  menus: 'Menus',
  indeterminate: 'Indeterminate',
  sizeAndWidth: 'Size & Width',
  rotate: 'Rotate',
  determinate: 'Determinate',
  buffer: 'Buffer',
  radiosDefault: 'Radios Default',
  radiosDirectionRow: 'Radios Direction Row',
  radiosDirectionColumn: 'Radios Direction Column',
  radiosColors: 'Radios - Colors',
  switchesColors: 'Switches - Colors',
  continuous: 'Continuous',
  discrete: 'Discrete',
  customColors: 'Custom Colors',
  editableNumericValue: 'Editable numeric value',
  contextualSnackbar: 'Contextual snackbar',
  showSnackbar: 'Show Snackbar',
  centeredTabs: 'Centered Tabs',
  toolbarTabs: 'Toolbar Tabs',
  theDefaultColorToolbar: 'The Default Color Toolbar',
  appBar: 'App Bar',
  appBarWithExtension: 'App Bar With Extension',
  visibility: 'Visibility',
  top: 'Top',
  right: 'Right',
  bottom: 'Bottom',
  left: 'Left',
  toggle: 'Toggle',
  timePicker: 'Time Picker',
  timePickerInDialogAndMenu: 'Time Picker - In Dialog And Menu',
  itemsAndHeaders: 'Items And Headers',
  selectableRows: 'Selectable Rows',
  headerCell: 'Header Cell',
  expand: 'Expand',
  recentChat: 'Recent Chat',
  previousChats: 'Previous chats',
  addNewItems: 'Add New Items',
  addToDo: 'Add To Do',
  yes: 'Yes',
  no: 'No',
  ok: 'Ok',
  activeUsers: 'Active Users',
  addNew: 'Add New',
  addNewStore: 'Add New Store',
  readMore: 'Read More',
  assignNow: 'Assign Now',
  totalRequest: 'Total Request',
  new: 'New',
  pending: 'Pending',
  update: 'Update',
  updated10MinAgo: 'Updated 10 min ago',
  addNewCustomer: 'Add New Customer',
  name: 'Name',
  email: 'Email',
  editMember: 'Edit Member',
  scheduleDate: 'Schedule Date',
  title: 'Title',
  newEmails: 'New Emails',
  newEmail: 'New Email',
  employeePayroll: 'Employee Payroll',
  forMostOfTheUsers: 'For most of the users',
  choosePlan: 'Choose Plan',
  mega: 'Mega',
  master: 'Master',
  forDeveloper: 'For developer',
  forLargeEnterprises: 'For large enterprises',
  composeEmail: 'Compose Email',
  mailboxes: 'Mailboxes',
  folders: 'Folders',
  inbox5: 'Inbox (5)',
  draft: 'Draft',
  starred: 'Starred',
  sentMessages: 'Sent Messages',
  spam: 'Spam',
  delete: 'Delete',
  work: 'Work',
  personal: 'Personal',
  manageFolders: 'Manage Folders',
  contacts: 'Contacts',
  settings: 'Settings',
  themeOptions: 'Theme Options',
  darkMode: 'Dark Mode',
  collapseSidebar: 'Collapse Sidebar',
  boxLayout: 'Box Layout',
  rtlLayout: 'Rtl Layout',
  backgroundImage: 'Background Image',
  sidebarFilters: 'Sidebar Filters',
  danger: 'Danger',
  primary: 'Primary',
  warning: 'Warning',
  success: 'Success',
  info: 'Info',
  dailySales: 'Daily Sales',
  trafficChannel: 'Traffic Channel',
  campaignPerformance: 'Campaign Performance',
  goToCampaign: 'Go To Campaign',
  fullScreen: 'Full Screen',
  ecommerce: 'E-Commerce',
  shop: 'Shop',
  cart: 'Cart',
  total: 'Total',
  totalPrice: 'Total Price',
  totalToPay: 'Total to pay',
  totalPurchases: 'Total Purchases',
  totalSold: 'Total Sold',
  totalSoldInBs: 'Total Sold in Ves',
  totalVerifiedSales: 'Total Verified Sales',
  identification: 'Identification',
  viewCart: 'View Cart',
  checkout: 'Checkout',
  apply: 'Apply',
  noItemsFound: 'No Items Found',
  billingDetails: 'Billing Details',
  placeOrder: 'Place Order',
  addNewCard: 'Add New Card',
  devicesShare: 'Devices Share',
  customers: 'Customers',
  myCustomers: 'My Customers',
  totalCustomers: 'Total Customers',
  customerOverview: 'Customer Overview',
  reviews: 'Reviews',
  weeklySales: 'Weekly Sales',
  recentOrders: 'Recent Orders',
  categorySales: 'Category Sales',
  webAnalytics: 'Web Analytics',
  topSelling: 'Top Selling',
  social: 'Social',
  newPost: 'New Post',
  publish: 'Publish',
  magazine: 'Magazine',
  editUser: 'Edit User',
  addNewUser: 'Add New User',
  dark: 'Dark',
  light: 'Light',
  recentUsers: 'Recent Users',
  activityAroundWorld: 'Activity Around World',
  adsIncome: 'Ads Income',
  recentComments: 'Recent Comments',
  recentNotifications: 'Recent Notifications',
  messages: 'Messages',
  message: 'Message',
  edit: 'Edit',
  topAuthors: 'Top Authors',
  marketingCampaign: 'Marketing Campaign',
  articles: 'Articles',
  websiteTraffic: 'Website Traffic',
  agency: 'Agency',
  recent: 'Recent',
  trending: 'Trending',
  totalPageViews: 'Total Page Views',
  impressions: 'Impressions',
  deviceSeparations: 'Device Separations',
  browserStatics: 'Browser Statics',
  totalDownloading: 'Total Downloading',
  notifications: 'Notifications',
  totalBookmarked: 'Total Bookmarked',
  itemsDownloads: 'Items Downloads',
  itemsUploaded: 'Items Uploaded',
  totalAnalytics: 'Total Analytics',
  hotKeywords: 'Hot Keywords',
  MaleUsers: 'Male Users',
  serverStatus: 'Server Status',
  purchaseVuely: 'Purchase Vuely',
  letsGetInTouch: 'Lets Get In Touch',
  maleUsers: 'Male Users',
  femaleUsers: 'Female Users',
  androidUsers: 'Android Users',
  iOSUsers: 'iOS Users',
  advance: 'Advance',
  routerAnimation: 'Router Animation',
  salesAndEarning: 'Sales And Earning',
  netProfit: 'Net Profit',
  totalExpences: 'Total Expences',
  photos: 'Photos',
  adCampaignPerfomance: 'Ad Campaign Perfomance',
  profitShare: 'Profit Share',
  topSellingTheme: 'Top Selling Theme',
  newRequest: 'New Request',
  followers: 'Followers',
  mailbox: 'Mailbox',
  sent: 'Sent',
  birthdays: 'Birthdays',
  events: 'Events',
  newsletter: 'Newsletter',
  lastMonth: 'Last Month',
  lastUpdate: 'Last Update',
  allTime: 'All Time',
  composeNewEmail: 'Compose New Email',
  activity: 'Activity',
  message: 'Message',
  selectTheme: 'Select Theme',
  continueShopping: 'Continue Shopping',
  proceedToCheckout: 'Proceed To Checkout',
  headerFilters: 'Header Filters',
  blog: "Blog",
  signUp: "Sign Up",
  login: "Login",
  news: "News",
  topHeadlines: "Top Headlines",
  visitors: "Visitors",
  subscribers: "Subscribers",
  twitterFeeds: "Twitter Feeds",
  extensions: "Extensions",
  imageCropper: "Image Cropper",
  videoPlayer: "Video Player",
  dropzone: "Dropzone",
  baseConfig: "Base Config",
  audioTrackAndPlaysInline: "Audio Track And Plays Inline",
  hlsLive: "HLS Live",
  forgotPassword: "Forgot Password",
	joinCommunity: "Visit our telegram group",
  resetPassword: "Reset Password",
  backToSignIn: "Back To Sign In",
  enterYourEmailToSendYouAResetLink: "Enter your email to send you a reset link",
  pleaseEnterYourNewPassword: "Please enter your new password",
  saas: "SAAS",
  overallTrafficStatus: "Overall Traffic Status",
  projectManagement: "Project Management",
  projectTaskManagement: "Project Task Management",
  totalSales: "Total Sales",
  totalSpent: "Total Spent",
  simple: "Simple",
  transitions: "Transitions",
  tax: "Tax",
  expenses: "Expenses",
  images: "Images",
  ratings: "Ratings",
  containAndCover: "Contain And Cover",
  height: "Height",
  fixedRatio: "Fixed Ratio",
  gradients: "Gradients",
  sizeVariants: 'Size Variants',
  newIcons: "New Icons",
  webApplication: "Web Application",
  person: "Person",
  file: "File",
  comment: "Comment",
  form: "Form",
  hardware: "Hardware",
  directional: "Directional",
  mapAliases: "Map (Aliases)",
  dateAndTime: "Date And Time",
  groups: "Groups",
  buttonGroups: "Button Groups",
  itemGroups: "Item Groups",
  windows: "Windows",
  onBoarding: "On Boarding",
  accountCreation: "Account Creation",
  treeview: "Treeview",
  customSelectableIcons: "Custom Selectable Icons",
  timelines: "Timelines",
  usage: "Usage",
  scopedSlots: "Scoped Slots",
  asyncItems: "Async Items",
  smallDots: "Small Dots",
  iconDots: "Icon Dots",
  coloredDots: "Colored Dots",
  oppositeSlot: "Opposite Slot",
  denseAlert: "Dense Alert",
  fixedTabs: "Fixed Tabs",
  rightAlignedTabs: "Right Aligned Tabs",
  content: "Content",
  withSearch: "With Search",
  iconsAndText: "Icons And Text",
  grow: "Grow",
  pagination: "Pagination",
  customIcons: "Custom Icons",
  courses: "Courses",
  coursesList: "Courses List",
  courseDetail: "Courses Detail",
  signIn: "Sign In",
  pay: 'Pay',
  paymentToDealer: 'Payment to dealer',
  payment: "Payment",
  paymentStatus: "Payments status",
  paymentRejected: "Payment rejected",
  LearnWithYourConvenience: "Learn With Your Convenience",
  management: "Management",
  design: "Design",
  development: "Development",
  top: "Top",
  new: "New",
  trending: "Trending",
  bestseller: "BestSeller",
  addToCart: "Add To Cart",
  popularInstructors: "Popular Instructors",
  moreCoursesFromJamesColt: "More Courses From James Colt",
  whatYoWillLearn: "What you Will learn",
  description: "Description",
  aboutInstructor: "About Instructor",
  userSignIn: "User Sign In",
  guestCheckout: "Guest Checkout",
  continueAsGuest: "Continue as Guest",
  paymentOptions: "Payment Options",
  offerCode: "Offer Code",
  enterCardDetails: "Enter Card Details",
  submit: "Submit",
  clear: "Clear",
  makePayment: "Make Payment",
  usage: "Usage",
  withContent: "With Content",
  customHeight: "Custom Height",
  banks: "Banks",
  accounts: "Accounts",
  permissions: "Permissions",
  localbitcoin: "Localbitcoin",
  localbitcoinAccounts: "Localbitcoin Accounts",
  payments: "Payments",
  deleteSelected: "Delete selected",
  trades: "Trades",
  tradeStatus: "Trade status",
  lastname: 'Lastname',
  store: 'Store',
  stores: 'Stores',
  storeAlias: 'Store Alias',
  storeBotName: 'Store Bot Name',
  storeProfile: 'Store Profile',
  storeSchedule: 'Store Schedule',
  storeName: 'Store Name',
  storeDescription: 'Store Description',
  storeCategory: 'Store Category',
  storeInformation: 'Store Information',
  faq: 'Frequently Asked Questions',
  catalogue: 'Catalogues',
  productList: 'Product List',
  product: 'Product',
  images: 'Images',
  addImages: 'Add Images',
  addImage: 'Add image',
  telegramUsers: 'Telegram users',
  shoppingList: 'Shopping List',
  shoppingDetails: 'Purchase details',
  shippingDetails: 'Shipping Details',
  shippingType: 'Shipping Type',
  bankList: 'Bank list',
  editBank: 'Edit Bank',
  addBank: 'Add Bank',
  subscription: 'Subscription',
  addTime: 'Add time',
  statuses: 'Statuses',
  status: 'Status',
  createDate: 'Create Date',
  expireDate: 'Expire date',
  save: 'Save',
  errorStoreName: 'Please, specify the name of store',
  errorStoreDescription: 'Please, specify the description of store',
  errorName: 'Please, specify the name',
  errorEmail: 'Please, specify the email',
  invalidEmail: 'Invalid email',
  errorStatus: 'Please, specify the status',
  actions: 'Actions',
  password: 'Password',
  confirmPassword: 'Confirme Password',
  confirmedBy: 'Confirmed by',
  numberMonths: 'Number of Months',
  telegramUser: 'Telegram User',
  mainTelegramUser: 'Main Telegram User',
  alternativeTelegramUser: 'Alternative Telegram User',
  telegramBotToken: 'Telegram Bot Token',
  latitude: 'Latitude',
  longitude: 'Longitude',
  howCreateBot: 'How to create the telegram bot',
  location: 'Location',
  addLocation: 'Add location',
  selectLocation: 'Select your store location',
  moneyType: 'Tipo de Moneda',
  accountType: 'Account Type',
  accountNumberIdentifier: 'Account Number/Identifier',
  accountNumber: 'Account Number',
  ownerName: 'Owner Name',
  editOwnerName: 'Edit Owner Name',
  ownerDocument: 'Owner Document',
  deleteConfirmation: 'Delete confirmation',
  deleteMessage: 'Are you sure you want to delete this?',
  bankName: 'Bank name',
  documentType: 'Document type',
  editCatalogue: 'Edit catalogue',
  addCatalogue: 'Add catalogue',
  errorDescription: 'Please, enter the description',
  sendMessageAllClients: 'Send message to all Clients',
  sendMessage: 'Send message',
  sendMessageTo: 'Send message to',
  send: 'Send',
  purchase: 'purchase',
  purchaseStatus: 'Purchase Status',
  purchaseDate: 'Purchase Date',
  startDate: 'Start date',
  endDate: 'End date',
  telegramId: 'telegram ID',
  client: 'Client',
  verified: 'Verified',
  verifieds: 'Verifieds',
  verify: 'Not Verified',
  rejected: 'Rejected',
  receiptImage: 'Receipt image',
  delivery: 'Delivery',
  deliveries: 'Deliveries',
  dealer: 'Dealer',
  dealers: 'Dealers',
  dealerId: 'Dealer Id',
  dealerName: 'Dealer Name',
  dealerLastname: 'Dealer Lastname',
  addDealer: 'Add Dealer',
  editDealer: 'Edit Dealer',
  dealerDetails: 'Dealer Details',
  deliveryEnabled: 'Delivery enabled',
  deliveryDisabled: 'Delivery disabled',
  delivered: 'Delivered',
  deliveryAddress: 'Delivery address',
  deliveryPrice: 'Delivery price',
  deliveryId: 'Delivery id',
  deliveryProfile: 'Delivery Profile',
  deliveryType: 'Delivery Type',
  deliveryDate: 'Delivery Date',
  products: 'Products',
  price: 'Price',
  quantity: 'Quantity',
  total: 'Total',
  confirmPayment: 'Confirm Payment',
  confirmShipping: 'Confirm Shipping',
  details: 'Details',
  errorPrice: 'Please, enter the price',
  errorCatalogue: 'Please, enter the catalogue',
  errorQuantity: 'Please, enter a valid quantity',
  sendPromo: 'Send promo',
  addFaq: 'Add Frequently Asked Questions',
  editFaq: 'Edit Frequently Asked Questions',
  question: 'Question',
  answer: 'Answer',
  rating: 'Rating',
  productsMoreSelled: 'Best selling Item',
  totalInSales: 'Total in Sales',
  totalInVes: 'Total in VES',
  topClients: 'Top clients',
  yadioRate: 'Yadio Rate',
  exchangeRate: 'Exchange rate',
  manualExchangeRate: 'Manual Exchange Rate',
  deny: 'Deny',
  denied: 'Denied',
  totalSalesVES: 'Total in Bolivares',
  sellsPerWeek: 'Sells Per Week',
  telephone: 'Telephone',
  address: 'Address',
  city: 'City',
  country: 'Country',
  state: 'State',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
  opening: 'Opening',
  closing: 'Closing',
  open: 'Open',
  closed: 'Closed',
  profile: 'Profile',
  schedule: 'Schedule',
  addressReference: 'Address Reference',
  newImage: 'New Image',
  storeUpdatedSuccessfully: 'Store has been updated successfully',
  sendBroadcast: 'Send Broadcast',
  topStores: 'Top Stores',
  percentageAboveDollar: 'Percentage Above Dollar',
  rate: 'Rate',
  rates: 'Rates',
  ratePreview: 'Rate Preview',
  extendMembership: 'Extend Membership',
  bank: 'Bank',
  confirmDelivery: 'Confirm Delivery',
  cashiers: 'Cashiers',
  addCashier: 'Add Cashier',
  editCashier: 'Edit Cashier',
  shippings: 'Shipping',
  shippingRates: 'Shipping Rates',
  paid: 'Paid',
  notPaid: 'Not Paid',
  privateKey: 'Private Key',
  id: "Id",
  totalPaid: 'Total Paid',
  shareLink: 'Share Link',
  registerAs: 'Register as',
  linkedStores: 'Linked Stores',
  deliveryCompany: 'Compañia de Delivery',
  deliveryCompanies: 'Delivery Companies',
  orderStatus: 'Order Status',
  paymentMethod: 'Payment Method',
  paymentMethods: 'Payment Methods',
  code: 'Code',
  primaryUserAdministrator: 'Primary User Administrator',
  secondaryUserAdministrator: 'Secondary User Administrator',
  companyName: 'Company Name',
  purchasesToVerify: 'Purchases to verify',
  deliveryCost: 'Delivery Cost',
  chargedBy: 'Charged by',
  allowCharges: 'Allow Charges',
  denyCharges: 'Deny Charges',
  shipped: 'Shipped',
  ownDelivery: 'Own Delivery',
  doesNotApply: 'Does Not Apply',
  pendingToPay: 'Pending to Pay',
  pendingToCharge: 'Pending to Charge',
  permissionToCharge: 'Permiso para cobrar',
  reports: 'Reports',
  export: 'Export',
  filter: 'Filter',
  reason: 'Reason',
  cancelShopping: 'Cancel shopping',
  cancellationReason: 'Cancellation Reason',
  cancelled: 'Cancelled',
  denyPayment: 'Deny payment',
  customersWithBills: 'Customers with bills',
  showInDirectory: 'Show in directory',
  token: 'Token',
  manual: 'Manual',
  available: 'Available',
  notAvailable: 'Not available',
  availability: 'Availability',
  responsibleName: 'Responsible name',
  order: 'Order',
  route: 'Route',
  routes: 'Routes',
  addRoute: 'Add route',
  editRoute: 'Edit route',
  from: 'From',
  to: 'To',
  percentage: 'Percentage',
  originCountry: 'Origin Country',
  originState: 'Origin State',
  originCity: 'Origin City',
  destinationCountry: 'Destination Country',
  destinationState: 'Destination State',
  destinationCity: 'Destination City',
  verifiedShippings: 'Verified Shippings',
  notVerifiedShippings: 'Not Verified Shippings',
  currency: 'Currency',
  accountNumberEmailPhone: 'Account number/E-mail/Phone',
  telegramConnection: 'Telegram connection',
  ratePerKm: 'Rate per Km',
  minimumRate: 'Minimum rate ',
  enableGeolocationCharge: 'Enable Geolocation Charge',
  disableGeolocationCharge: 'Disable Geolocation Charge',
  observation: 'Observation',
  dashboardEvents: "Events",
  clients: "Clients",
  bills: "Bills",
  bots: "Bots",
  active: "Active",
  inactive: "Inactive",
  addEvent: "Add Event",
  fee: "Fee",
  webUrl: "Web url",
  errorFee: "Please, enter the fee",
  telegramBotUser: "Telegram bot user",
  telegramBotToken: "Telegram bot token",
  telegramBotUserError: "Please, enter the telegram bot user",
  telegramBotTokenError: "Please, enter the telegram bot token",
  someWentWrong: "Something went wrong.",
  section: "Section",
  sectionError: "Please, enter the section",
  eventIdError: "Please, enter the event id",
  eventId: "Event id",
  webUrlError: "Please, enter the  web url",
  confirmContinue: "Click to continue?",
  accountCreation: "Edit account",
  aproved: "Aproved",
  specialAcount: "Special account",
  ticket_quantity: "Quantity",
  text: "Buy Description",
}
